var map = {
	"./es.png": 1518,
	"./es_old.png": 7596,
	"./hs.png": 2098,
	"./hs_old.png": 7843,
	"./ms.png": 7702,
	"./ms_old.png": 1972,
	"./ps.png": 717,
	"./ps_old.png": 1371,
	"./ss.png": 5215,
	"./ss_old.png": 8794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1813;